// @flow

import React from 'react';
import type {
  BusinessPlanBean,
  kpiData,
  StoreGemini,
  VisioglobeUnitsMap,
  YearMonth,
} from '../../../../types/geminiType';
import GeminiSideData from './GeminiSideData';
import BusinessPlanSideData from './BusinessPlanSideData';
import MapViewer from '../mapviewer';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';

type Props = {
  dispatch: () => void,
  history: History,
  isTabCollapsed: boolean,
  collapseTab: Function,
  shoppingCenter: ShoppingCenter,
  mapviewer: MapViewer,
  visioglobeUnitsMap: VisioglobeUnitsMap,
  updateVisioglobeUnits: Function,
  changeMappingMode: Function,
  business: kpiData[],
  store: StoreGemini,
  className: string,
  title: string,
  selectedCategory: string,
  storeBranchLevel: string,
  categoryOverride: boolean,
  yearMonth: YearMonth,
  showComparable: Function,
  showChart: Function,
  selectedBusinessPlan: ?BusinessPlanBean,
  onQuitBusinessPlanView: Function,
  isButton: boolean,
  isPerf: boolean,
  isGeminiAdmin: boolean,
  isPulseAuthorized: boolean,
}

class GeminiRightTab extends React.PureComponent<Props> {
  renderContent = () => (
    this.props.selectedBusinessPlan
      ? (
        <BusinessPlanSideData
          businessPlan={
            this.props.selectedBusinessPlan
          }
          history={this.props.history}
          onClose={this.props.collapseTab}
          onQuitBusinessPlanView={this.props.onQuitBusinessPlanView}
        />
      ) : (
        <GeminiSideData
          dispatch={this.props.dispatch}
          shoppingCenter={this.props.shoppingCenter}
          history={this.props.history}
          mapviewer={this.props.mapviewer}
          visioglobeUnitsMap={this.props.visioglobeUnitsMap}
          updateVisioglobeUnits={this.props.updateVisioglobeUnits}
          changeMappingMode={this.props.changeMappingMode}
          business={this.props.business}
          selectedStore={this.props.store}
          title={this.props.title}
          selectedCategory={this.props.selectedCategory}
          storeBranchLevel={this.props.storeBranchLevel}
          categoryOverride={this.props.categoryOverride}
          onClose={this.props.collapseTab}
          yearMonth={this.props.yearMonth}
          showComparable={this.props.showComparable}
          showChart={this.props.showChart}
          isButton={this.props.isButton}
          isGeminiAdmin={this.props.isGeminiAdmin}
          isPulseAuthorized={this.props.isPulseAuthorized}
        />
      )
  )

  render() {
    if (!this.props.isPerf) {
      return false;
    }
    return (
      <div
        role="presentation"
        onClick={!this.props.isTabCollapsed ? this.props.collapseTab : null}
        className={!this.props.isTabCollapsed ? 'side-data-gemini-hidden exit-button side-data-container' : `side-data-container right-data ${this.props.className || ''}`}
      >
        {
          !this.props.isTabCollapsed
            ? (
              <i className="fal fa-chevron-left left-chevron" />
            ) : (
              this.renderContent()
            )
        }
      </div>
    );
  }
}

export default GeminiRightTab;
